import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Merci, {{name}}',
    confirmation_email:
      'Vous recevrez bientôt un e-mail de confirmation avec votre numéro de commande de la part de notre partenaire {{provider_email}}',
    need_help: "Besoin d'aide ?",
  },
  labels: {
    order_number: 'Commande n° : {{number}}',
    order_number_short: '#{{number}}',
    today: "Aujourd'hui",
    was_prefix: 'était',
    restaurant: 'Restaurant',
    order_details: 'Détails de la commande',
    your_details: 'Vos coordonnées',
    contact: 'Contact',
    payment: 'Paiement',
    payment_method: 'Mode de paiement',
    delivery: 'Livraison',
    delivery_details: 'Détails de livraison',
    pickup_details: 'Détails du retrait',
    pickup_instruction: '📋 Indiquez votre numéro de commande {{number}} lors du retrait.',
    billing_info: 'Informations de facturation',
    order_summary: 'Récapitulatif de commande',
    help: "Besoin d'aide ? Contactez-nous au {{phone_number}}",
  },
  status: {
    canceled: 'Commande annulée',
    received: 'Commande reçue',
    confirmed: 'Commande confirmée !',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'À emporter',
    [ORDER_METHODS.DELIVERY]: 'Livraison',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Service en chambre',
      [RoomServiceLocationType.TableService]: 'Service à table',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(chambre n°{{details}})',
    [RoomServiceLocationType.TableService]: '(table n°{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Points gagnés',
      from_order: 'points sur cette commande',
      total_balance: 'Solde total',
      reward_value: 'Valeur de la récompense',
      redeem_hint: "✓ Vous pouvez utiliser jusqu'à {{points}} pts ({{amount}}) sur votre prochaine commande",
      points_to_redeem: 'Il vous manque {{points}} points pour utiliser votre récompense',
    },
    guest: {
      pill_title: 'Récompenses',
      earned_heading: 'Vous avez gagné <highlight>{{points}} points</highlight> sur cette commande',
      worth_on_next: 'Valeur de <strong>{{amount}}</strong> sur votre prochaine commande',
      ready_to_claim: 'Prêt à utiliser',
      next_order_discount: 'Remise sur la prochaine commande',
      claim_cta: 'Réclamez vos {{points}} pts — inscription gratuite',
      claim_note: '30 secondes · vos points sont crédités instantanément',
    },
  },
  buttons: {
    back_to_menu: 'Retour au menu',
    back_to_checkout: 'Retour au paiement',
    contact_us: 'Contactez-nous au {{phone_number}}',
    try_again: 'Réessayer',
  },
  loading: {
    processing_payment: 'Veuillez ne pas quitter la page pendant le traitement de votre paiement',
  },
  success_messages: {
    order_placed: {
      title: '✅ Commande réussie !',
      description: 'Votre commande a été passée avec succès.',
    },
  },
  error_messages: {
    failed_to_load: 'Impossible de charger la commande. Veuillez réessayer.',
    payment_failed: 'Paiement échoué, veuillez réessayer',
  },
  load_failed: {
    title: 'Nous n’avons pas pu charger votre commande',
    description:
      'Un problème est survenu lors du chargement des détails de votre commande. Veuillez réessayer. Si le problème persiste, contactez le support et nous vous aiderons immédiatement.',
  },
};
